import { Company, ListOptionsCompany, UserCompany } from "definitions/Company";
import { Ticket } from "definitions/Ticket";
import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  ReactNode,
} from "react";

interface NotificationContextValue {
  addSelectedCompany: (data: Partial<Company>) => void;
  selectedCompany: Partial<Company>;
  update: any;
  updateNotificationCount: boolean;
  triggerUpdateNotificationCount: () => void;
  handleUpdate: (data: any) => void;
  setUpdate: React.Dispatch<React.SetStateAction<any>>;
  headerSelectedTicket: { id: number; ticket: Ticket } | null;
  updateHeaderSelectedTicket: (id: number, ticket: Ticket) => void;
  hideTopBar: boolean;
  toggleTopBar: () => void;
  setListOptionsCompanies: React.Dispatch<
    React.SetStateAction<ListOptionsCompany[]>
  >;
  listOptionsCompanies: ListOptionsCompany[];
  updateTicketList: number;
  handleUpdateTicketList: () => void;
  setSelectedCompany: React.Dispatch<React.SetStateAction<Partial<Company>>>;
  listCompanies: UserCompany[];
  setListCompanies: React.Dispatch<React.SetStateAction<UserCompany[]>>;
  isNetworkOnline: boolean;
  notificationsCounter: number;
  setNotificationsCounter: React.Dispatch<React.SetStateAction<number>>;
}

const NotificationContext = createContext<NotificationContextValue | undefined>(
  undefined
);

const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [update, setUpdate] = useState<any>(false);
  const [updateNotificationCount, setUpdateNotificationCount] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<Partial<Company>>({});
  const [listOptionsCompanies, setListOptionsCompanies] = useState<
    ListOptionsCompany[]
  >([]);
  const [headerSelectedTicket, setHeaderSelectedTicket] = useState<{
    id: number;
    ticket: Ticket;
  } | null>(null);
  const [updateTicketList, setUpdateTicketList] = useState(0);
  const [hideTopBar, setHideTopBar] = useState(false);
  const [listCompanies, setListCompanies] = useState<UserCompany[]>([]);
  const [isNetworkOnline, setIsNetworkOnline] = useState(true);
  const [notificationsCounter, setNotificationsCounter] = useState(0);

  useEffect(() => {
    window.addEventListener("offline", (e) => {
      setIsNetworkOnline(false);
    });

    window.addEventListener("online", (e) => {
      setIsNetworkOnline(true);
    });
  }, []);

  const addSelectedCompany = (data: Partial<Company>) => {
    setSelectedCompany(data);
    // console.log(id, data)
  };

  const triggerUpdateNotificationCount = () => {
    //ficar invertendo o boolean só pra triggar o useEffect e atualizar o count
    setUpdateNotificationCount((oldState) => !oldState);
  };

  const handleUpdate = (data: any) => {
    setUpdate(data);
  };

  const updateHeaderSelectedTicket = (id: number, ticket: Ticket) => {
    setHeaderSelectedTicket({ id, ticket });
  };

  const toggleTopBar = () => {
    setHideTopBar(!hideTopBar);
  };

  const handleUpdateTicketList = () => {
    setUpdateTicketList(updateTicketList + 1);
  };

  return (
    <NotificationContext.Provider
      value={{
        addSelectedCompany,
        selectedCompany,
        update,
        updateNotificationCount,
        triggerUpdateNotificationCount,
        handleUpdate,
        setUpdate,
        headerSelectedTicket,
        updateHeaderSelectedTicket,
        hideTopBar,
        toggleTopBar,
        setListOptionsCompanies,
        listOptionsCompanies,
        updateTicketList,
        handleUpdateTicketList,
        setSelectedCompany,
        listCompanies,
        setListCompanies,
        isNetworkOnline,
        notificationsCounter,
        setNotificationsCounter,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

function useNotification() {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error(
      "useNotification must be used within an NotificationProvider"
    );
  }

  return context;
}

export { NotificationProvider, useNotification };
